export const truncateText = (text = '', maxLength = 80) => text.length > maxLength ? `${text.substring(0, maxLength - 3)}...` : text;
//# sourceMappingURL=truncate-text.js.map